<template>
  <v-main class="fill-height pa-2 idcs-main-list">
    <v-row align="center" align-content="center">
      <v-col cols="12" sm="3">
        <v-select
          v-model="filter.bin"
          :items="$store.getters['admin/bins']"
          :label="$t('fields.bin')"
          item-value="bin"
          item-text="name"
          clearable
        ></v-select>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="3">
        <v-text-field v-model="filter.domen" clearable :label="$t('fields.domen')"></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field v-model="filter.serialid" clearable :label="$t('fields.card')"></v-text-field>
      </v-col>
      <v-col cols="1" class="text-right">
        <v-btn icon @click="loadData">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="pagination"
      :items-per-page.sync="itemPerPage"
      :page.sync="currentPage"
      item-key="idx"
      class="transparent fill-height"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
      :server-items-length="totalItems"
      show-expand
    >
      <template v-slot:item.actions="{item}">
        <v-btn icon @click="$api.sendPushNotification(item.serial)">
          <v-icon color="primary">mdi-send-circle</v-icon>
        </v-btn>
        <v-icon v-if="item.details" color="grey">mdi-information</v-icon>
      </template>
      <template #expanded-item="{item, headers}">
        <td v-if="item.details" :colspan="headers.length">
          <v-row>
            <v-col v-for="(v,k) in item.details" :key="k">
              <div>{{k}}</div>
              <div>{{v}}</div>
            </v-col>
          </v-row>
        </td>
      </template>
      <template v-slot:item.created="{item}">{{item.created | dt-time}}</template>
      <template v-slot:item.updated="{item}">{{item.updated | dt-time}}</template>
    </v-data-table>
    <div>{{result}}</div>
  </v-main>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";

export default {
  name: "WalletCards",
  mixins: [commonmixin],
  data() {
    return {
      filter: {
        status: "",
        type_: "",
        serialid: "",
      },
      pattern: "",
      result: "",
      totalItems: 0,

      headers: [
        {
          text: "",
          value: "actions",
        },
        {
          text: this.$t("fields.created"),
          value: "created",
        },
        {
          text: this.$t("fields.updated"),
          value: "updated",
        },
        {
          text: this.$t("fields.card"),
          value: "serial",
        },
        {
          text: this.$t("fields.domen"),
          value: "domen",
        },
        {
          text: this.$t("fields.type"),
          value: "cardType",
        },
        {
          text: this.$t("fields.deviceid"),
          value: "deviceId",
        },
        {
          text: this.$t("fields.bin"),
          value: "bin",
        },
      ],
    };
  },
  watch: {
    pagination: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
  },
  methods: {
    sendNotification(i) {
      this.$api.sendPushNotification(i.pushToken).then((r) => {
        this.result = r;
      });
    },
    loadData() {
      this.$api
        .getWalletDevices({
          sortBy: this.pagination.sortBy,
          sortDesc: this.pagination.sortDesc,
          filter: { ...this.filter, pattern: this.pattern },
          limit: this.pagination.itemsPerPage,
          offset: (this.pagination.page - 1) * this.pagination.itemsPerPage,
        })
        .then((r) => {
          this.totalItems = r.total;
          this.items = r.items;
        });
    },
  },
  mounted() {},
};
</script>

<style>
</style>